import { IEbayMessagingStats } from "../../models/EbayMessage";

// Placeholder values for the Messages redesign while
// `GET /ebaymessaging/stats` is still pending on the backend.
// Tracked in docs/pending-endpoints.md — replace with the real
// response as soon as the endpoint ships.
//
// userStats userIds are intentionally random hex so they resolve to a
// generic avatar via `stringToColour` rather than matching a real
// Wilma user. `useWilmaUsers` will fall back to showing the id itself,
// which is obvious-enough placeholder output.
export const SAMPLE_EBAY_MESSAGING_STATS: IEbayMessagingStats = {
  totalMessaged: 247,
  totalAwaitingResponse: 32,
  flaggedForAssistance: 5,
  userStats: [
    {
      userId: "sample-user-amelia",
      displayName: "Amelia Hart",
      repliesSent: 64,
      averageReplyMinutes: 18,
    },
    {
      userId: "sample-user-james",
      displayName: "James Okoye",
      repliesSent: 41,
      averageReplyMinutes: 34,
    },
    {
      userId: "sample-user-priya",
      displayName: "Priya Shah",
      repliesSent: 27,
      averageReplyMinutes: 52,
    },
    {
      userId: "sample-user-tom",
      displayName: "Tom Wallace",
      repliesSent: 14,
      averageReplyMinutes: 95,
    },
    {
      userId: "sample-user-chloe",
      displayName: "Chloe Barker",
      repliesSent: 6,
      averageReplyMinutes: 210,
    },
  ],
};
